import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskCloneComponent } from './task-clone.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { CtButtonModule } from '@ctsolution/ct-framework';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

/**
 * Module per il componente di clonazione Task
 * 
 * Fornisce:
 * - TaskCloneComponent per la duplicazione dei task
 * - Import necessari (Dialog Material, Button Framework)
 * - Provider per il corretto funzionamento dei dialog
 */
@NgModule({
  imports: [
    CommonModule,
    MatLegacyDialogModule,
    CtButtonModule
  ],
  declarations: [TaskCloneComponent],
  exports: [TaskCloneComponent],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ]
})
export class TaskCloneModule { }
